$(function () {
  if (!customElements.get('about-user-stories')) {
    customElements.define(
      'about-user-stories',
      class aboutUserStories extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }

        init() {
          const $tabs = this.querySelectorAll('.tab');
          const $mySwiper = this.querySelector('.mySwiper');

          const swiper = new Swiper($mySwiper, {
            spaceBetween: 20,
            on: {
              slideChange: (swiper) => {
                // 移除之前的 active 类
                $(this).find('.tab.active').removeClass('active');
                $($tabs[swiper.realIndex]).addClass('active');
                const tabBox = $(this).find('.tabs')[0];
                if (tabBox) {
                  const tab = $($tabs[swiper.realIndex])[0];
                  const tabRect = tab.getBoundingClientRect();
                  const boxRect = tabBox.getBoundingClientRect();
                  const targetScroll =
                    tabBox.scrollLeft + tabRect.left - boxRect.left - (boxRect.width - tabRect.width) / 2;

                  tabBox.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth',
                  });
                }
              },
            },
          });

          if (swiper.slides.length < 1) {
            swiper.destroy();
          }
          // 使用 jQuery 来绑定事件
          $($tabs).each((index, tab) => {
            $(tab).on('click', (event) => {
              // 移除之前的 active 类
              $(this).find('.tab.active').removeClass('active');
              // 添加 active 类到当前 tab
              $(tab).addClass('active');
              swiper.slideTo($(event.target).data('index'));
            });
          });

          // 初始化位置
          $($tabs[0]).click();
        }
      }
    );
  }
});
